import { Availability, ChaletNameEnum } from "./availability.model";
import { dateToString, formatDateYYYYMMDD, moneyToString, scrollToTop, setStepQS, Variables } from "./common";
import { getRoomInfo } from "./room-config";
import { Step2 } from "./step2";

/**
 * Using singleton design pattern
 */
export class Step1 {

    private static _instance: Step1;

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() {
        sessionStorage.removeItem('booking-state-pushed');
        setStepQS(null);
    }

    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    public static get instance(): Step1 {
        if (!Step1._instance) {
            Step1._instance = new Step1();
        }

        return Step1._instance;
    }



    private stepId = "pricesTable";

    private $templateElement = Variables.$('#dvAvailabilityCardTemplate');

    /**
    * hide : hides step 1
    */
    public hide() {
        Variables.$(`#${this.stepId}`).addClass("hidden");
    }

    /**
     * show : shows step 1
     */
    public show() {
        Variables.$(`#${this.stepId}`).removeClass("hidden");
        scrollToTop(this.stepId);
        setStepQS(null);
    }



    private availabilities: Availability[];
    public makeCards = (_availabilities: Availability[]) => {

        this.availabilities = _availabilities.filter(avb => avb.arrivalDate > new Date());

        this.availabilities.forEach((availability, index) => {

            this.setupDivider(index, availability);

            const $card = this.$templateElement.clone(true);

            $card.removeAttr('id');
            $card.show();
            $card.appendTo(this.$templateElement.parent());

            // setting up data attributes that are being used for CSS
            // note: using data method instead of attr does not work see: https://stackoverflow.com/a/14935227/1730846
            this.addDataAttributes($card, availability);

            if (availability.isFullyBooked) {
                $card.addClass('booked')
            }

            $card.find('.date').text(dateToString(availability.arrivalDate));
            $card.find(`.propertyName.${availability.name}`).show();

            this.setupSpacesAvailable(availability, $card);


            this.setupNotes(availability, $card);


            this.setupPricing(availability, $card);

            this.setupBookingAndAccordion(availability, $card);


            // handling onClick of  "Book Now" button - redirect to new booking page
            $card.find(`.bookNow`).click({ availability }, (event) => {
                const avail = event.data.availability;
                // Format dates without timezone conversion to preserve intended date
                const arrivalDate = formatDateYYYYMMDD(avail.arrivalDate);
                const departureDate = formatDateYYYYMMDD(avail.departureDate);
                const chaletName = encodeURIComponent(avail.name);

                window.location.href = `/booking/index.php?name=${chaletName}&arrivalDate=${arrivalDate}&departureDate=${departureDate}`;
            });


        });
    }



    private setupDivider(index: number, availability: Availability) {
        if (index === 0 || availability.arrivalDate.getMonth() !== this.availabilities[index - 1].arrivalDate.getMonth()) {
            const $divider = Variables.$('#dvDividerTemplate').clone(true);

            $divider.removeAttr('id');
            $divider.show();
            $divider.text(availability.arrivalDate.toLocaleDateString('en-ie', { month: 'long', year: 'numeric' }));
            $divider.appendTo(this.$templateElement.parent());

            $divider
                .attr('data-month-name', availability.arrivalDate.toLocaleDateString('en-ie', { month: 'short' }));
        }
    }

    private setupBookingAndAccordion(availability: Availability, $card: any) {

        // if chalet is exclusive use, show whole chalet text
        if (availability.isPricePerPerson === false) {
            $card.find(`.bookingAndAccordion .pricingBasis.whole-chalet`).show();


            $card.find(`span[data-empty-span]`).show();



        } else { // if chalet is not exclusive, then individual rooms can booked
            $card.find(`.bookingAndAccordion .rooms`).show();
            const $roomingDiv = $card.find(`.bookingAndAccordion .rooming`);

            // for each room, create an empty div and add it to rooming Div
            for (let i = 0; i < availability.roomsBooked.length; i++) {
                const isRoomBooked = availability.roomsBooked[i];

                // Use room-config module instead of DOM-dependent Step2.findRoom()
                const roomInfo = getRoomInfo(i, availability.name);
                const $newRoom = Variables.$(`<div>${roomInfo.abbreviation}</div>`);

                if (isRoomBooked === true) {
                    $newRoom.addClass('booked');
                }

                $roomingDiv.append($newRoom);
            }
        }

    }



    private setupPricing(availability: Availability, $card: any) {
        let perPersonText: string = '';

        if (availability.isPricePerPerson) {
            perPersonText = "pp";
        }

        // if the price is available, show that
        if (availability.currentPrice)
            $card.find(`.pricingOptions .price`).text(moneyToString(availability.currentPrice) + perPersonText);

        $card.find(`.pricingOptions .holidayDuration`).text(`${availability.duration} nts`);

        if (availability.duration < 7) {
            $card.addClass('shortBreak');
        }

        if (availability.discount) {
            $card.find(`.pricingOptions .originalPrice`)
                .show()
                .text(moneyToString(availability.originalPrice) + perPersonText);
        }
    }

    private setupNotes(availability: Availability, $card: any) {
        if (availability.notes) {
            $card.find(`.notes p`).text(availability.notes);
        } else {
            $card.find(`.notes`).remove();
        }
    }

    private setupSpacesAvailable(availability: Availability, $card: any) {
        const spaceText = availability.minPax === availability.maxPax ? `${availability.minPax}` : `${availability.minPax}-${availability.maxPax}`;
        $card.find(`.spacesAvailable`).text(spaceText);
    }

    private addDataAttributes($card: any, availability: Availability) {
        $card
            .attr('data-accom-name', availability.name)
            .attr('data-special-offer', availability.discount ? "True" : "False")
            .attr('data-product-enhancement-special-offer', availability.productEnhancements ? "True" : "False")
            .attr('data-school-holiday', availability.schoolHoliday)
            .attr('data-pricing-basis', availability.isPricePerPerson ? "PerPerson" : "Exclusive use")
            //.attr('data-arrival-date', availability.arrivalDate.toDateString())
            ;
    }
}
